export const getBreadCrumb = (area, pref, golfName) => {
  if (!area) {
    return []
  } else if (!pref) {
    if (area === 'okinawa') {
      return [
        { text: 'ライブカメラ', link: useCdnUrl('/') },
        { text: getPrefectureName(area) }
      ]
    }
    return [
      { text: 'ライブカメラ', link: useCdnUrl('/') },
      { text: areaToPrefTable.find(({ key }) => key === area).name }
    ]
  } else if (!golfName) {
    return [
      { text: 'ライブカメラ', link: useCdnUrl('/') },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: useCdnUrl(`/${area}/`) },
      { text: getPrefectureName(pref) }
    ]
  } else {
    return [
      { text: 'ライブカメラ', link: useCdnUrl('/') },
      { text: areaToPrefTable.find(({ key }) => key === area).name, link: useCdnUrl(`/${area}/`) },
      { text: getPrefectureName(pref), link: useCdnUrl(`/${area}/${pref}/`) },
      { text: golfName }
    ]
  }
}
